module.exports = __webpack_public_path__ + "static/media/TheBreakupListsBookJacket.fe66883f.jpg";